import React, { useState } from 'react';
import cx from 'classnames';

const InputText = ({ type = 'text', name, id, label, value, setFunc, error = false }) => {
    const [focus, setFocus] = useState(false);
    const handleFocus = () => {
        setFocus(true);
    };
    const handleBlur = () => {
        setFocus(false);
    };
    const handleChange = (e) => {
        setFunc(e.target.value);
    };

    return (
        <div className={cx('input-text', { focus, 'not-empty': value !== '', error })}>
            <label htmlFor={id}>{label}</label>
            <div className="input-box">
                <input
                    className="input-field"
                    type={type}
                    name={name}
                    id={id}
                    value={value}
                    onChange={handleChange}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                />
            </div>
            {error === true && <div className="input-error">Error. Invalid Entry.</div>}
        </div>
    );
};

export default InputText;
